import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cd20226a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "career_interest_form",
    id: "form",
    style: `background: #FFF`
};
const _hoisted_2 = { class: "container" };
const _hoisted_3 = ["id"];
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-lg-12" };
const _hoisted_6 = { class: "form__field float-label" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "name" }, "Name*", -1));
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "col-lg-12" };
const _hoisted_10 = { class: "form__field float-label" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "email" }, "Email*", -1));
const _hoisted_12 = { class: "row" };
const _hoisted_13 = { class: "col-lg-12" };
const _hoisted_14 = { class: "form__field float-label" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "message" }, "Message", -1));
const _hoisted_16 = {
    class: "row mt-5",
    id: "attachment"
};
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "row mt-5" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-lg-12 privacy-policy" }, [
        /*#__PURE__*/ _createTextVNode(" By submitting this form, I agree that Absolute may use personal data in accordance with the "),
        /*#__PURE__*/ _createElementVNode("a", {
            href: "/privacy-policy",
            class: "no-style"
        }, "privacy policy.")
    ])
], -1));
const _hoisted_18 = { class: "row" };
const _hoisted_19 = { class: "col-lg-12 mt-2" };
const _hoisted_20 = ["value", "disabled"];
const _hoisted_21 = {
    key: 0,
    class: "form__message--wrapper"
};
const _hoisted_22 = { class: "status" };
const _hoisted_23 = ["innerHTML"];
import { computed, ref, defineComponent, onMounted } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';
import { masterForm } from '../mixins/masterForm';
import vueFilePond from 'vue-filepond';
// Import FilePond styles
import "filepond/dist/filepond.min.css";
const formId = 21;
export default /*#__PURE__*/ _defineComponent({
    __name: 'career_interest_form',
    props: ['d'],
    setup(__props) {
        const props = __props;
        const subject = props.d.subject;
        const name = ref('');
        const emailAddress = ref('');
        const message = ref('');
        const attachments = ref();
        const recaptchaSiteKey = window.Laravel.recaptchaSiteKey;
        const recaptchaResponse = ref('');
        const formSubmitting = ref(false);
        const formSuccess = ref(false);
        const formError = ref(false);
        const formMessage = ref('');
        const textareaHeight = computed(() => {
            return message.value.trim() !== '' ? '10rem' : '';
        });
        // Function to inject the script
        const injectScript = (src) => {
            return new Promise((resolve, reject) => {
                if (!document.querySelector(`script[src="${src}"]`)) {
                    const script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.src = src;
                    script.async = true;
                    script.onload = resolve;
                    script.onerror = reject;
                    document.head.appendChild(script);
                }
            });
        };
        // Function to execute reCAPTCHA
        const executeRecaptcha = (recaptchaSiteKey, formId, recaptchaResponse) => {
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(recaptchaSiteKey, { action: 'formcategory' + formId })
                    .then((token) => {
                    if (token) {
                        recaptchaResponse.value = token;
                        document.getElementById('recaptchaResponse' + formId)?.setAttribute('value', token);
                    }
                })
                    .catch((error) => {
                    console.error('Error executing reCAPTCHA:', error);
                });
            });
        };
        onMounted(() => {
            injectScript('https://www.google.com/recaptcha/api.js?render=' + recaptchaSiteKey)
                .then(() => {
                executeRecaptcha(recaptchaSiteKey, formId, recaptchaResponse);
            })
                .catch((error) => {
                console.error('Error loading reCAPTCHA script:', error);
            });
        });
        const rules = {
            name: { required },
            emailAddress: { required, email },
            message: {},
            attachments: {},
        };
        const v$ = useVuelidate(rules, {
            name,
            emailAddress,
            message,
            attachments
        });
        function canSubmit() {
            if (formSubmitting.value) {
                return false;
            }
            if (v$) {
                // Check if the form is invalid
                return !v$.value.$invalid;
            }
            // If v$ doesn't exist, assume form cannot be submitted
            return false;
        }
        const handleSubmit = () => {
            if (!canSubmit()) {
                return;
            }
            formSubmitting.value = true;
            masterForm.methods.submitForm({
                category_id: formId,
                name: name.value,
                email: emailAddress.value,
                message: message.value,
                attachments: attachments.value,
                subject: 'Job Interest Enquiry',
                recaptcha_response: recaptchaResponse.value
            }, handleResponse, true);
        };
        const handleResponse = (response) => {
            if (response.status === 'success') {
                formSuccess.value = true;
                // Push the event to the dataLayer for GTM
                window.dataLayer?.push({
                    'event': 'form_submit',
                    'form': 'career_interest',
                    'subject': 'Job Interest',
                });
                // Form has been successfully submitted, so we can reset the form
                name.value = '';
                emailAddress.value = '';
                message.value = '';
                attachments.value = [];
            }
            else {
                formError.value = false;
            }
            // When we show a message, we set the formSubmitting flag to false
            formSubmitting.value = false;
            formMessage.value = response.message;
        };
        // Create component
        const FilePond = vueFilePond();
        // Defining the file types and extensions allowed to be uploaded
        const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/bmp', 'image/gif', 'application/pdf'];
        const allowedFileExtensions = ['jpeg', 'jpg', 'png', 'bmp', 'gif', 'pdf'];
        // Initialize FilePond
        const filePondOptions = {
            storeAsFile: true,
            required: true,
            allowProcess: false,
            maxFiles: 3,
            allowMultiple: true,
            credits: {},
            dropValidation: true,
            instantUpload: false,
            labelIdle: '<div class="filepond-label-container"><svg viewBox="0 0 59 59" xmlns="http://www.w3.org/2000/svg"><clipPath id="a"><path d="m0 .489h36v36h-36z"/></clipPath><rect fill="#fff" height="59" rx="3" width="59" transform="matrix(1, 0, 0, 1, 3.552713678800501e-15, 3.552713678800501e-15)"/><g clip-path="url(#a)" fill="#303030" transform="matrix(1, 0, 0, 1, 12.000000000000007, 11.512000083923343)"><path d="m26.558 36.489h-16.952a.565.565 0 0 1 -.565-.565v-2.26a.565.565 0 1 1 1.13 0v1.7h15.822v-1.7a.565.565 0 1 1 1.13 0v2.26a.565.565 0 0 1 -.565.565"/><path d="M 18.082 11.062 C 17.916 11.062 17.758 11.135 17.651 11.262 L 11.435 18.608 C 11.154 18.94 11.338 19.452 11.766 19.529 C 11.799 19.535 11.832 19.538 11.866 19.538 L 14.691 19.538 L 14.691 26.884 C 14.691 27.196 14.944 27.449 15.256 27.449 L 20.907 27.449 C 21.219 27.449 21.472 27.196 21.472 26.884 L 21.472 19.538 L 24.301 19.538 C 24.736 19.538 25.008 19.067 24.79 18.69 C 24.773 18.661 24.754 18.634 24.732 18.608 L 18.516 11.262 C 18.409 11.135 18.251 11.062 18.085 11.062 M 13.085 18.408 L 18.085 12.502 L 23.085 18.408 L 20.913 18.408 C 20.601 18.408 20.348 18.661 20.348 18.973 L 20.348 26.319 L 15.828 26.319 L 15.828 18.973 C 15.828 18.661 15.575 18.408 15.263 18.408 L 13.085 18.408 Z" style=""/><path d="M 20.907 29.144 L 15.256 29.144 C 14.821 29.144 14.549 29.615 14.767 29.991 C 14.868 30.166 15.054 30.274 15.256 30.274 L 20.907 30.274 C 21.342 30.274 21.614 29.803 21.396 29.426 C 21.295 29.252 21.109 29.144 20.907 29.144" style=""/><path d="M 20.907 31.969 L 15.256 31.969 C 14.821 31.969 14.549 32.44 14.767 32.816 C 14.868 32.991 15.054 33.099 15.256 33.099 L 20.907 33.099 C 21.342 33.099 21.614 32.628 21.396 32.251 C 21.295 32.077 21.109 31.969 20.907 31.969" style=""/><path d="m35.6 34.225a.565.565 0 0 1 -.565-.565v-24.06l-8.146-8.145h-25.189a.566.566 0 0 0 -.57.57v31.638a.565.565 0 1 1 -1.13 0v-31.638a1.7 1.7 0 0 1 1.7-1.7h25.423a.565.565 0 0 1 .4.165l8.477 8.476a.565.565 0 0 1 .165.4v24.3a.565.565 0 0 1 -.565.565"/><path d="m35.599 9.931h-7.911a1.131 1.131 0 0 1 -1.13-1.13v-2.26a.565.565 0 1 1 1.13 0v2.26h7.911a.565.565 0 1 1 0 1.13"/></g></svg>' + getMobileUploadText() + '</div>',
            acceptedFileTypes: allowedFileTypes,
            onaddfile: (error, file) => {
                // Check if a file is present and its extension is not in the allowed list
                if (file && !allowedFileExtensions.includes(file.fileExtension.toLowerCase())) {
                    FilePond.removeFile(file.id);
                }
            },
            minFileSize: '1b',
            maxFileSize: '20mb',
            iconRemove: "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 377 447\" width=\"377\" height=\"447\" preserveAspectRatio=\"xMidYMid meet\" style=\"width: 100%; height: 100%; transform: translate3d(0px, 0px, 0px); content-visibility: visible;\"><defs><clipPath id=\"__lottie_element_47\"><rect width=\"377\" height=\"447\" x=\"0\" y=\"0\"></rect></clipPath></defs><g clip-path=\"url(#__lottie_element_47)\"><g transform=\"matrix(0.7071068286895752,0.7071067690849304,-0.7071067690849304,0.7071068286895752,188.39700317382812,223.35400390625)\" opacity=\"1\" style=\"display: block;\"><g opacity=\"1\" transform=\"matrix(1,0,0,1,0,0)\"><path fill=\"rgb(255,255,255)\" fill-opacity=\"1\" d=\" M-159.66099548339844,-26.610000610351562 C-159.66099548339844,-26.610000610351562 159.66099548339844,-26.610000610351562 159.66099548339844,-26.610000610351562 C159.66099548339844,-26.610000610351562 159.66099548339844,26.610000610351562 159.66099548339844,26.610000610351562 C159.66099548339844,26.610000610351562 -159.66099548339844,26.610000610351562 -159.66099548339844,26.610000610351562 C-159.66099548339844,26.610000610351562 -159.66099548339844,-26.610000610351562 -159.66099548339844,-26.610000610351562z\"></path></g></g><g transform=\"matrix(0.7071068286895752,-0.7071067690849304,0.7071067690849304,0.7071068286895752,188.5,223.3979949951172)\" opacity=\"1\" style=\"display: block;\"><g opacity=\"1\" transform=\"matrix(1,0,0,1,0,0)\"><path fill=\"rgb(255,255,255)\" fill-opacity=\"1\" d=\" M-159.66099548339844,-26.610000610351562 C-159.66099548339844,-26.610000610351562 159.66099548339844,-26.610000610351562 159.66099548339844,-26.610000610351562 C159.66099548339844,-26.610000610351562 159.66099548339844,26.610000610351562 159.66099548339844,26.610000610351562 C159.66099548339844,26.610000610351562 -159.66099548339844,26.610000610351562 -159.66099548339844,26.610000610351562 C-159.66099548339844,26.610000610351562 -159.66099548339844,-26.610000610351562 -159.66099548339844,-26.610000610351562z\"></path></g></g></g></svg>",
        };
        // Create component
        defineComponent({
            components: {
                FilePond // Register the FilePond component
            },
            setup() {
                // Other setup logic...
                return {
                    filePondOptions,
                };
            }
        });
        // Apply mixins or do other setup logic
        const applyMixins = () => {
            // Apply masterForm mixin
            Object.assign({}, masterForm);
        };
        // Drag and drop element
        function getMobileUploadText() {
            // Check if the device is a mobile or tablet, with a special consideration for iPad Pro
            var isMobile = /iPhone|iPad|iPod|Android|Windows Phone/i.test(navigator.userAgent) || (navigator.userAgent.includes("Mac") && navigator.maxTouchPoints > 0);
            const desktopText = '<span>Drag and drop your attachments here (e.g., CV, portfolio), or <span class="filepond--label-action">click to browse.</span></span>';
            const mobileText = '<span><span class="filepond--label-action">Click</span> to upload your attachments (e.g., CV, portfolio)</span>';
            return isMobile ? mobileText : desktopText;
        }
        function updatedFiles(files) {
            const fileList = files.map(file => file.file);
            attachments.value = fileList;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("form", {
                        onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event) => (handleSubmit()), ["prevent"]))
                    }, [
                        _createElementVNode("input", {
                            type: "hidden",
                            name: "recaptcha_response",
                            id: 'recaptchaResponse' + formId,
                            value: ""
                        }, null, 8, _hoisted_3),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "name",
                                        tabindex: "1",
                                        placeholder: "Please enter your name",
                                        type: "text",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(v$).name.$model) = $event))
                                    }, null, 512), [
                                        [_vModelText, _unref(v$).name.$model]
                                    ]),
                                    _hoisted_7
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "email",
                                        tabindex: "3",
                                        placeholder: "Please enter your email",
                                        type: "text",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(v$).emailAddress.$model) = $event))
                                    }, null, 512), [
                                        [_vModelText, _unref(v$).emailAddress.$model]
                                    ]),
                                    _hoisted_11
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _withDirectives(_createElementVNode("textarea", {
                                        id: "message",
                                        tabindex: "6",
                                        placeholder: "Message",
                                        style: _normalizeStyle({ height: textareaHeight.value }),
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(v$).message.$model) = $event))
                                    }, null, 4), [
                                        [_vModelText, _unref(v$).message.$model]
                                    ]),
                                    _hoisted_15
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                            _createVNode(_unref(FilePond), _mergeProps({ name: "attachments" }, filePondOptions, {
                                modelValue: _unref(v$).attachments.$model,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(v$).attachments.$model) = $event)),
                                onUpdatefiles: updatedFiles,
                                onAddfiles: _ctx.addNewFiles,
                                files: attachments.value
                            }), null, 16, ["modelValue", "onAddfiles", "files"])
                        ]),
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("input", {
                                    class: _normalizeClass(["button button--green", { 'is-submitting': formSubmitting.value }]),
                                    type: "submit",
                                    value: formSubmitting.value ? 'Submitting...' : 'Submit',
                                    disabled: !canSubmit()
                                }, null, 10, _hoisted_20)
                            ])
                        ])
                    ], 32),
                    (formSuccess.value || formError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("span", _hoisted_22, _toDisplayString(formSuccess.value ? 'Success' : 'Error'), 1),
                            _createElementVNode("span", {
                                class: "form__message",
                                innerHTML: formMessage.value
                            }, null, 8, _hoisted_23)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
